import "./Foot.css";

const Foot = () => {
  return <footer className="footer">&copy; Kevin Brandt, 2024</footer>;
};

export default Foot;
